import { render, staticRenderFns } from "./ActiveBacklog.vue?vue&type=template&id=63a40e1d&"
import script from "./ActiveBacklog.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports